   var isLoggedin = false;
   var markup = 1.0;
   var t;
   var stones = [];
   var ajaxurl;
   var addtocartpopupurl;
   var addtocarturl;
   var searchSnUrl;
   
   function SetAjaxUrl(url, p_addtocartpopupurl, p_addtocarturl, p_searchSnUrl )
   {
      ajaxurl = url;
      addtocartpopupurl = p_addtocartpopupurl;
      addtocarturl = p_addtocarturl;
      searchSnUrl = p_searchSnUrl;
   }
   
   function imgClickHandler() 
   {
         $(".StoneBox img").click( function() {       
            var elem = $(this).siblings('input');
            if (elem.attr('checked') === true)
               $(elem).attr('checked', false);
            else
               $(elem).attr('checked', true);
            SetStonePic(elem.attr('id'));            
         });
   }   
   
   function CheckBoxClickHandler()
   {
      var evt = $.browser.msie ? "click" : "change";         
      $(".StoneCheck").bind(evt, function() {
          SetStonePic(this.id);
        });
        
      $(".SetsCheck").bind(evt, function() {
         $('#curPage').val('1');
         GetStones();
      });       
   }

   function SubmitPage()
   {
      $('#curPage').val(1);
      GetStones();
   }
   
   function PrintHandler()
   {
      $('#hrefPriceList').click( function () {
         PrintStones();
      });
   }
   
   function PrintStones() {

   	var stoneCount = $('#stoneCount').text();
   	if (stoneCount == undefined || stoneCount == "0") {
   		alert('Nothing to print');
   	}
   	else {
   		if (parseInt(stoneCount) > 1000) {
   			var iReallyWantTo = confirm("Are you sure you want to print " + stoneCount + " stones?");
   			if (iReallyWantTo) {
   				GatherCriteria();
   			}
   		}
   		else {
   			GatherCriteria();
   		}
   	}      
					
   }

   function GatherCriteria() {
   	var lowPrice = (50000 * (Math.pow(2.71828, (-0.00106 * $('#PriceSliderRailBody').slider("value", 1))))).toFixed(0);
   	var highPrice = (50000 * (Math.pow(2.71828, (-0.00106 * $('#PriceSliderRailBody').slider("value", 0))))).toFixed(0);
   	var lowCarat = (7 * (Math.pow(2.71828, (-0.02 * $('#CaratSliderRailBody').slider("value", 1))))).toFixed(2);
   	var highCarat = (7 * (Math.pow(2.71828, (-0.02 * $('#CaratSliderRailBody').slider("value", 0))))).toFixed(2);
   	var lowClrty = Math.round(($('#ClaritySliderRailBody').slider("value", 0) / 20));
   	var highClrty = Math.round(($('#ClaritySliderRailBody').slider("value", 1) / 20));
   	var lowColor = Math.round($('#ColorSliderRailBody').slider("value", 0) / 20);
   	var highColor = Math.round($('#ColorSliderRailBody').slider("value", 1) / 20);
   	var lowCut = Math.round(($('#CutSliderRailBody').slider("value", 0) / 25));
   	var highCut = Math.round(($('#CutSliderRailBody').slider("value", 1) / 25));
   	var sList = GetShapeList();
   	var cList = GetCertList();
   	var sets = $("input[name='rdoMatched']:checked").val();
   	if (sets == undefined || sets.length == 0)
   		sets = false;

   	MakeAjaxCall(1, sList, lowPrice, highPrice, lowCarat, highCarat, lowClrty, highClrty, lowColor, highColor, lowCut, highCut,
							cList, "initial", "asc", "each", 10000, sets, true);
   }
   
   function LoadSliders()
   {
      LoadCaratSlider();
      LoadCutSlider();
      LoadColorSlider();
      LoadClaritySlider();
      //GetLoginAttr();
      LoadPriceSlider();
   }

   function LoadCaratSlider()
   {
      $('#CaratSliderRailBody').slider({handle: '.dualSliderHandleStyle',                     
                                                     range: true,                  
                                                     min: 0,
                                                     max: 183,
                                                     slide: function(e,ui){ updateSlider(e,ui);}
                                                     });               
      
   }
     
   function LoadCutSlider()
   {
      $('#CutSliderRailBody').slider({handle: '.dualSliderHandleStyle', 
                                                     range: true,                                                                 
                                                     max: 100,
                                                     slide: function(e,ui){ updateSlider(e,ui);},
                                                     change: function(e,ui) { 
                                                         SnapCut(e,ui);}                                                         
                                                     });               
   }
   
   function SnapCut(e,ui)
   {
      if (((parseInt(ui.value) % 25) != 0) && (ui.range > 5)) {
         var lsat = Math.round(ui.value/25);
         lsat = lsat * 25;
         $('#CutSliderRailBody').slider("moveTo", lsat, ui.handle[0]);
      }
   }
/*   function CutLookup(cutCode)
   {
         var cut="NA";         
         switch(cutCode) {
            case 0 :
               cut = "Ideal";
               break;
            case 1 : 
               cut = "Excellent";
               break;
            case 2 :           
               cut = "Very Good";
               break;
            case 3 :
               cut = "Good";
               break;
            case 4 :
               cut = "Fair";
               break;
         }
         return cut;
   }*/
  
   function LoadColorSlider()
   {
      $('#ColorSliderRailBody').slider({handle: '.dualSliderHandleStyle', 
                                                     range: true,                                                                       
                                                     max: 160,                                                     
                                                     slide: function(e,ui){ updateSlider(e,ui);},
                                                     change: function(e,ui) {
                                                         SnapColor(e,ui);}
                                                     });               
   }
   
   function SnapColor(e, ui)
   {
      if (((parseInt(ui.value) % 20) != 0) && (ui.range > 5)) {
         var lsat = Math.round(ui.value/20);
         lsat = lsat * 20;
         $('#ColorSliderRailBody').slider("moveTo", lsat, ui.handle[0]);
      }
   }
   
   function ColorLookup(colorCode)
      {
         var color="NA";         
         switch(colorCode) {
            case 0 :
               color = "D";
               break;
            case 1 :
               color = "E";
               break;
            case 2 :
               color = "F";
               break;
            case 3 :
               color = "G";
               break;
            case 4 :
               color = "H";
               break;
            case 5 :
               color = "I";
               break;
            case 6 :
               color = "J";
               break;
            case 7 :
               color = "K-O";
               break;
         }
         return color;
      }

   function LoadClaritySlider()
   {
      $('#ClaritySliderRailBody').slider({handle: '.dualSliderHandleStyle', 
                                                     range: true,                                                                       
                                                     max: 200,                                                     
                                                     slide: function(e,ui){ updateSlider(e,ui);},
                                                     change: function(e,ui) {
                                                         SnapClarity(e,ui);}
                                                     });   
   }
   
   function SnapClarity(e, ui)
   {
      if (((parseInt(ui.value) % 20) != 0) && (ui.range > 5)) {
         var lsat = Math.round(ui.value/20);
         lsat = lsat * 20;
         $('#ClaritySliderRailBody').slider("moveTo", lsat, ui.handle[0]);
      }
   }
   
   function LoadPriceSlider()
   {   
      if ($('#ctl00_content_loggedin').val() == "True")
         isLoggedin = true;
      else
         isLoggedin = false;
         
      markup = parseFloat($('#ctl00_content_markup').val());
      var highPrc = (50000 * markup).toFixed(0);
      var lowPrc = (250 * markup).toFixed(0);
      
      $('#highPrice').text(highPrc);
      $('#lowPrice').text(lowPrc);
      
                  $('#PriceSliderRailBody').slider({handle: '.dualSliderHandleStyle',                     
                                                     range: true,                  
                                                     min: 0,
                                                     max: 5000,
                                                     slide: function(e,ui){ updateSlider(e,ui);}
                                                     });               
      if (isLoggedin == false)
         $('#PriceSliderWrapper').hide();
      else
         $('#PriceSliderWrapper').show();
                                                     
   }
   
   function updateSlider(e, ui)
   {
      var id = ui.handle[0].id;
      var lsat=0;
      
      switch(id) {
         case 'CaratLeftHandle' :
            //lsat = (100/(ui.value + 6)).toFixed(2) + ' ct';
            lsat = (7 * (Math.pow(2.71828, (-0.02*ui.value)))).toFixed(2);
            $('#highCarat').text(lsat);            
            break;
         case 'CaratRightHandle' :
            //lsat = (100/(ui.value + 6)).toFixed(2) + ' ct';
            lsat = (7 * (Math.pow(2.71828, (-0.02*ui.value)))).toFixed(2);
            $('#lowCarat').text(lsat);
            break;
         case 'PriceLeftHandle' :            
            //lsat = '$' + ((15000 * markup) - (((Math.pow((16 * markup), (ui.value/100))*1000))-1000)).toFixed(0);
            lsat = (50000*(Math.pow(2.71828, (-0.00106*ui.value)))).toFixed(0);
            $('#highPrice').text(lsat * markup);
            break;
         case 'PriceRightHandle' :
            //lsat = '$' + ((15000 * markup) - (((Math.pow((16 * markup), (ui.value/100))*1000))-1000)).toFixed(0);
            lsat = (50000*(Math.pow(2.71828, (-0.00106*ui.value)))).toFixed(0);
            $('#lowPrice').text(lsat * markup);
            break;
       }       
/*                case 'CutLeftHandle' :
            lsat = ui.value / 25;
            $('#lowCut').text(CutLookup(lsat));
            break;
         case 'CutRightHandle' :
            lsat = ui.value / 25;
            $('#highCut').text(CutLookup(lsat));
            break;
         case 'ColorLeftHandle' :
            lsat = ui.value / 20;
            $('#lowColor').text(ColorLookup(lsat));
            break;
         case 'ColorRightHandle' :
            lsat = ui.value / 20;
            $('#highColor').text(ColorLookup(lsat));
            break;
         case 'ClarityLeftHandle' :
            lsat = ui.value / 20;
            $('#lowClarity').text(ClarityLookup(lsat));
            break;
         case 'ClarityRightHandle' :
            lsat = ui.value / 20;
            $('#highClarity').text(ClarityLookup(lsat));
            break;*/
   }
   
  	function chkShape_Click(id)
  	{
  	   SetStonePic(id);	            
   }

   function select_stone(id) {
      if ($('#' + id).attr('checked') == true)
         $('#' + id).attr('checked', false);	   
      else
         $('#' + id).attr('checked', true);	   
     SetStonePic(id);     
   } 

   function SetStonePic(id)
   {
     	var imgid = $('#' + id).siblings().get(0);
     	var tmpId;
     	if (id == 'baguettes')     	
     	   tmpId = 'straightbaguette';
     	else
     	   tmpId = id;
  	   if ($('#' + id).attr('checked') == true)
  	      $(imgid).attr('src', '/images/diamonds/' + tmpId + '.png');
  	   else
  	      $(imgid).attr('src','/images/diamonds/outlines/' + tmpId + '.png');  	      
   }
   
   function CheckStonePics(){
      var CheckBoxIDs = $('.StoneCheck');
  	   for (var i = 0;i < CheckBoxIDs.length; i++) {
    	   SetStonePic(CheckBoxIDs[i].id);
      }
   }
   
   function GetShapeList()
    	{    	
    	   var CheckBoxIDs = $('.StoneCheck');
   	   var shapelist = [];
    	   var strArr;
    	   var tmpshape;
    	   var shape;
    	   for (var i = 0;i < CheckBoxIDs.length; i++) {
    	         if (CheckBoxIDs[i].checked == true){
    	            tmpshape = CheckBoxIDs[i].id;
    	            switch(tmpshape)
    	            {
    	               case "baguettes":
    	                  shapelist.push("tapered baguette");
    	                  shapelist.push("straight baguette");
    	                  break;
    	               case "pear":
                        shapelist.push("pear shape");
                        break;
                     case "heart":
                        shapelist.push("heart shape");
                        break;
                     case "emerald":                     
                        shapelist.push("emerald cut");
                        break;
                     case "princess":
                        shapelist.push("square");
                        break;
                     case "triangle":
                        shapelist.push("trillion");
                        break;
                     default:
                        shapelist.push(tmpshape);
                  }
/*    	            if (shapelist == '')
    	               shapelist = shape;
    	            else
    	               shapelist = shapelist + ', ' + shape;*/
    	         }
    	      }    	      
    	   var str = shapelist.join(',');
    	   return str;    	   
    	}
    	
   function GetCertList()
   {
      var CheckBoxIDs = $('.ReportChk');
   	var reptlist = [];
  	   for (var i = 0;i < CheckBoxIDs.length; i++) {
  	      if (CheckBoxIDs[i].checked == true) {
  	          reptlist.push(CheckBoxIDs[i].id);
  	      }
  	   }  	   
  	   var str = reptlist.join(',');
  	   return str;
   }

   function GetStones() {
   	if (isLoggedin) {
   		var lowPrice = (50000 * (Math.pow(2.71828, (-0.00106 * $('#PriceSliderRailBody').slider("value", 1))))).toFixed(0);
   		var highPrice = (50000 * (Math.pow(2.71828, (-0.00106 * $('#PriceSliderRailBody').slider("value", 0))))).toFixed(0);
   	}
   	else {
   		var lowPrice = 250;
   		var highPrice = 50000;
   	}

   	//var lowPrice = ((15000) - (((Math.pow((16), ($('#PriceSliderRailBody').slider("value", 1)/100))*1000))-1000)).toFixed(0);
   	//var highPrice = ((15000) - (((Math.pow((16), ($('#PriceSliderRailBody').slider("value", 0)/100))*1000))-1000)).toFixed(0);                                   
   	var lowCarat = (7 * (Math.pow(2.71828, (-0.02 * $('#CaratSliderRailBody').slider("value", 1))))).toFixed(2);
   	var highCarat = (7 * (Math.pow(2.71828, (-0.02 * $('#CaratSliderRailBody').slider("value", 0))))).toFixed(2);
   	//var lowCarat = (100/($('#CaratSliderRailBody').slider("value", 1) + 6)).toFixed(2);
   	//var highCarat = (100/($('#CaratSliderRailBody').slider("value", 0) + 6)).toFixed(2);
   	var lowClrty = Math.round(($('#ClaritySliderRailBody').slider("value", 0) / 20));
   	var highClrty = Math.round(($('#ClaritySliderRailBody').slider("value", 1) / 20));
   	var lowColor = Math.round($('#ColorSliderRailBody').slider("value", 0) / 20);
   	var highColor = Math.round($('#ColorSliderRailBody').slider("value", 1) / 20);
   	/*      if (highColor == 'K-O')
   	highColor = 'O';*/
   	var lowCut = Math.round(($('#CutSliderRailBody').slider("value", 0) / 25));
   	var highCut = Math.round(($('#CutSliderRailBody').slider("value", 1) / 25));

   	var sList = GetShapeList();
   	var cList = GetCertList();
   	var pageSize = $('#pagesize option:selected').text();
   	var sortField = $('#sortField').val();
   	var sortDir = $('#sortDir').val();
   	var pageNum = $('#curPage').val();
   	var pricetype = $('#pricetype option:selected').text();
   	var sets = $("input[name='rdoMatched']:checked").val();
   	if (sets == undefined || sets.length == 0)
   		sets = false;

   	MakeAjaxCall(pageNum, sList, lowPrice, highPrice, lowCarat, highCarat, lowClrty, highClrty, lowColor, highColor, lowCut, highCut, cList,
						   sortField, sortDir, pricetype, pageSize, sets, false);

   }
         
     function MakeAjaxCall(pageNum, sList, lowPrice, highPrice, lowCarat, highCarat, lowClrty, highClrty, lowColor, highColor, lowCut, highCut, cList, 
						   sortField, sortDir, pricetype, pageSize, sets, issuePrint)
	 {
           
      var parmString = "{'pageNum':'" + pageNum + "','shapes':'" + sList + "','lowPrice':'" + lowPrice + "','highPrice':'" + highPrice + "','lowCarat':'" + lowCarat
                     + "','highCarat':'" + highCarat + "','lowClrty':'" + lowClrty + "','highClrty':'" + highClrty + "','lowColor':'" + lowColor 
                     + "','highColor':'" + highColor + "','lowCut':'" + lowCut + "','highCut':'" + highCut + "','reports':'" + cList  
                     + "','sortField':'" + sortField + "','sortDir':'" + sortDir + "','pricetype':'" + pricetype + "','pagesize':'" + pageSize + "', 'sets':'" + sets + "'}";
      $("#loadingtext").html("Retrieving Diamonds...");
      $('#indicator').show();
      $('#Loading').show();      
           
     //kpr 2/2/09 - if the shape list or the cert list is 0 then there's no point in making a server trip
     if ((sList.length > 0) && (cList.length > 0)) 
       $('#Results').load(
          ajaxurl, {pageNum: pageNum, shapes: sList, lowPrice: lowPrice, highPrice: highPrice, lowCarat: lowCarat, highCarat: highCarat, lowClrty: lowClrty, 
                     highClrty: highClrty, lowColor: lowColor, highColor: highColor, lowCut: lowCut, highCut: highCut, reports: cList, sortField: sortField, sortDir: sortDir,
                     pricetype: pricetype, pagesize: pageSize, sets: sets},
            function(result)
            {               
               FinishUp(issuePrint);               
            }
         );
     else {
        $('#Results').empty('');  
        
        if (sList.length == 0) {
           $('#loadingtext').html('Select a shape to begin');
           $('#loadingbg span').css('left', '32px');
           $('#loadingbg span').css('top', '24px');
           $('#indicator').hide();
        }
        else {
           $('#loadingtext').html('Select a Report type');
           $('#loadingbg span').css('left', '50px');
           $('#loadingbg span').css('top', '24px');
           $('#indicator').hide();
        }     
     }    
     //error: function(req, msg, err) { ShowError(req, msg, err);}, 
   }
   
   function ShowError(req, msg, err, caller)
   {
      if (req.responseText.length > 0) 
     	   var xml = '<?xml version="1.0"?>\n' +
   		   '<error>\n' +
	   	   '<name>' + req.status + '</name>\n' +
		      '<message>' +
		      '<![CDATA[' + 
		      req.responseText + 
		      '\n\n' +		      
            ']]>\n' +
		      '</message>\n' +
		      '<location>' + caller + '</location>\n' +
		      '</error>';	
       else
     	   var xml = '<?xml version="1.0"?>\n' +
   		   '<error>\n' +
	   	   '<name>' + req.status + '</name>\n' +
		      '<message>' +
		      '<![CDATA[' + 
		         'Response Text is nothing' + 
		      '\n\n' +		      
            ']]>\n' +
		      '</message>\n' +
		      '<location>' + caller + '</location>\n' +
		      '</error>';	
         
            $.ajax({
               type: "POST",
               url: "/err/JSError.aspx",
               data: xml,
               contentType: "text/xml"
            });
      //$('#errMsg').html(req.responseText);
      //$('#divError').show();
   }
   
   function FinishUp(doPrint) {     
    
    if ($('.StoneCheck:checked').length == 0) {
           $('#loadingtext').html('Select a shape to begin');
           $('#loadingbg span').css('left', '32px');
           $('#loadingbg span').css('top', '24px');
    }     
    var sets = $("input[name='rdoMatched']:checked").val();
    SetSortArrow();    
    $('#Loading').hide();
    $('.addclick').click(function() { addtocartpopupserialized(this, 0, addtocartpopupurl, addtocarturl, $("#cartReferrerMaster").val(), function() { GetStones(); } ); return false; });
    if (doPrint)
    	window.print();
   }
   function ChangePageSize()
   {
      $('#curPage').val(1);
      GetStones();
   }
   
   function ChangePage(page)
   {
      $('#curPage').val(page);
      GetStones();
   }
      
   function ImgError(source)
   {
       source.src = "//meteor.stullercloud.com/das/71896339?$standard$";    
      source.onerror = "";    
      return true;
   }
      
   function popCompare(compareurl)   
   {
      var compList = $('.CompareCheck');
      var serNumList = [];
      var NumList=[];
      for (var i=0;i < compList.length;i++){
         if (compList[i].checked == true)
            serNumList.push(compList[i].id);
      }
      if (serNumList.length > 1) {
          var url = compareurl + "?serialnumberlist=" + serNumList.join(',');
          stuller.windowHelper.openScrollingWindow("Compare", url, 750, 550);
          //$('#divCompare').load(url);      
      }      
   }
   
   function ResetCompare()
   {
            $('#cmp_image td').remove();
            $('#cmp_serialnum td').remove();
            $('#cmp_totalprice td').remove();
            $('#cmp_caratprice td').remove();
            $('#cmp_rappaport td').remove();
            $('#cmp_shape td').remove();
            $('#cmp_weight td').remove();
            $('#cmp_cut td').remove();
            $('#cmp_color td').remove();
            $('#cmp_clarity td').remove();
            $('#cmp_depthpct td').remove();
            $('#cmp_tablepct td').remove();
            $('#cmp_mmsize td').remove();
            $('#cmp_report td').remove();
            $('#cmp_symmetry td').remove();
            $('#cmp_girdle td').remove();
            $('#cmp_mindia td').remove();
            $('#cmp_maxdia td').remove();
            $('#cmp_culet td').remove();
            $('#cmp_agta td').remove();
            $('#cmp_ideal td').remove();
            $('#cmp_russian td').remove();
            $('#cmp_notes td').remove();
   }

   function changeSort(field)
   {
      if ($('#sortField').val() == field){
         if ($('#sortDir').val() == 'desc')
            $('#sortDir').val('asc');
         else
            $('#sortDir').val('desc');
      }
      else {
         $('#sortField').val(field);
         $('#sortDir').val('asc');
      }
      $('#curPage').val(1);
      GetStones();      
   }
   
   function SetSortArrow() {
      $('.sortarrow').addClass('hide');
      var id = $('#sortField').val();
      $('#' + id).children().removeClass('hide');            
      /*$('#sortarrow').remove();
      var imgHTML = '<img id="sortarrow" src="/img/';*/
      var imgHTML;
      if ($('#sortDir').val() == 'asc')
         imgHTML = '/img/sort_asc.gif';
      else
         imgHTML = '/img/sort_desc.gif';
                  
      $('#' + id).children().attr('src', imgHTML);
   }
     
   function changePriceSlider()
   {
      checkSliderCss();
      GetStones();
   }
   
   function checkSliderCss()
   {
      var pricetype = $('#pricetype option:selected').text();
      if (pricetype == 'carat') {
         $('#divLowPrice').css('border', 'solid 1px #54b27f');
         $('#divHighPrice').css('border', 'solid 1px #54b27f');
         $('#PriceLeftHandle').css('background-image', 'url(/images/diamonds/slider/greenhandle.gif)');
         $('#PriceRightHandle').css('background-image', 'url(/images/diamonds/slider/greenhandle.gif)');         
      }
      else {
         $('#divLowPrice').css('border', 'solid 1px #D67275');
         $('#divHighPrice').css('border', 'solid 1px #D67275');
         $('#PriceLeftHandle').css('background-image', 'url(/images/diamonds/slider/sliderArrow.gif)');
         $('#PriceRightHandle').css('background-image', 'url(/images/diamonds/slider/sliderArrow.gif)');
      }
   }
   
   function keySlider(elem)
   {      
      var xval;
      switch(elem.id) {
         case "lowPrice":
           if (elem.value > 250 && elem.value < 50000) {
               xval = (Math.log(elem.value/50000)/-0.00106).toFixed(0);
               if (xval < $('#PriceSliderRailBody').slider("value", 0))
                  $('#PriceSliderRailBody').slider("moveTo", $('#PriceSliderRailBody').slider("value", 0)-237, 1);
               else
                  $('#PriceSliderRailBody').slider("moveTo", xval, 1);
           }  
           break;
         case "highPrice": 
            if (elem.value < 50000 && elem.value > 250) {
               xval = (Math.log(elem.value/50000)/-0.00106).toFixed(0);
               if (xval > $('#PriceSliderRailBody').slider("value", 1))
                  $('#PriceSliderRailBody').slider("moveTo", $('#PriceSliderRailBody').slider("value", 1)+237, 0);
               else
                  $('#PriceSliderRailBody').slider("moveTo", xval, 0);
            }  
            break;          
         case "lowCarat":
            if (elem.value > 0.18 && elem.value < 7.00) {
               xval = (Math.log(elem.value/7)/-0.02).toFixed(2);
               if (xval < $('#CaratSliderRailBody').slider("value", 0))
                  $('#CaratSliderRailBody').slider("moveTo", $('#CaratSliderRailBody').slider("value", 0)-8, 1);
               else
                  $('#CaratSliderRailBody').slider("moveTo", xval, 1);
            }
            break;
         case "highCarat":
            if (elem.value > 0.18 && elem.value < 7.00) {
               xval = (Math.log(elem.value/7)/-0.02).toFixed(2);
               if (xval > $('#CaratSliderRailBody').slider("value", 1))
                  $('#CaratSliderRailBody').slider("moveTo", $('#CaratSliderRailBody').slider("value", 0)+8, 0);
               else
                  $('#CaratSliderRailBody').slider("moveTo", xval, 0);
            }
            break;
       }            
   }

   
   function showExtraCriteria()
   {
      if ($('#btnCriteria').html() == 'Standard Search Criteria') {
         $('#divExtraCriteria').slideDown();
         $('#divExtraCriteria').hide();
         $('#divCriteria').show();
         $('#btnCriteria').html('Advanced Search Criteria');
      }
      else {
         $('#divCriteria').slideUp();
         $('#divExtraCriteria').show();
         $('#btnCriteria').html('Standard Search Criteria');
      }
   }
   
   function Reset()
   {
      //Reset Stone shapes - only round is clicked
      var StoneBoxIDs = $('.StoneCheck');
      for (var i = 0;i < StoneBoxIDs.length; i++) {
    	   //if (StoneBoxIDs[i].id == 'round')
    	     // StoneBoxIDs[i].checked = true;
    	   //else
    	   StoneBoxIDs[i].checked = false;
    	   SetStonePic(StoneBoxIDs[i].id);
      }
      
      //Reset Report checkboxes - all should be checked
      var ReportBoxIDs = $('.ReportCheck');
      for (i = 0;i < ReportBoxIDs.length; i++) {
         ReportBoxIDs[i].checked = true;
      }
      
      //Reset sliders to min and max
      $('#CaratSliderRailBody').slider("moveTo", 0, 0);
      $('#CaratSliderRailBody').slider("moveTo", 183, 1);
      $('#CutSliderRailBody').slider("moveTo", 0, 0);
      $('#CutSliderRailBody').slider("moveTo", 100, 1);
      $('#ColorSliderRailBody').slider("moveTo", 0, 0);
      $('#ColorSliderRailBody').slider("moveTo", 160, 1);
      $('#ClaritySliderRailBody').slider("moveTo", 0, 0);
      $('#ClaritySliderRailBody').slider("moveTo", 200, 1);
      $('#PriceSliderRailBody').slider("moveTo", 0, 0);
      $('#PriceSliderRailBody').slider("moveTo", 5000, 1);
      
   }
   
//   function CheckQueryString()
//   {      
//      var itemnumber = $.query.get('itemnumber');
//      if (itemnumber.length > 0)
//         GetStonesByItem(itemnumber);
//         
//   }
//   
//   function GetStonesByItem(itemnumber)
//   {
//      var parmString =  "{'itemnumber':'" + itemnumber + "'}";
//            $.diamondAjax({           
//            type: "POST",
//            url: "/products/serializeddiamonds.aspx/GetStonesByItem",          
//            data: parmString,
//            contentType: "application/json; charset=utf-8",
//            dataType: "json",            
//            error: function(req, msg, err) { ShowError(req, msg, err, 'GetStonesByItem(' + parmString + ')'); },
//            success: function(msg) {
//               ApplyTemplate(msg);            
//            }
//          });
//   }
   
      function ReversColorLookup(color)
      {         
         var val;
         switch(color) {
            case "D" :
               val = 0;
               break;
            case "E" :
               val = 20;
               break;
            case "F" :
               val = 40;
               break;
            case "G" :
               val = 60;
               break;
            case "H" :
               val = 80;
               break;
            case "I" :
               val = 100;
               break;
            case "J" :
               val = 120;
               break;
            case "K-O" :
               val = 140;
               break;
         }
         return val;
      }
      
      function HighLightRow(row)
      {
         var rows = $('#grdSerializedResults tr');
         for (var i = 0;i < rows.length;i++)
            $('#' + rows[i].id).removeClass('highlight');
         
         $('#' + row).addClass('highlight');
      }     
